import { connect } from 'react-redux'

import * as selectors from '../selectors'
import Admin from '../components/Admin'


const mapStateToProps = state => {

    return {
        isLoadingUsers: selectors.isLoadingUsers(state),
        users: selectors.getUsers(state)
    }
};


export default connect(mapStateToProps)(Admin)



/** WEBPACK FOOTER **
 ** ./src/containers/AdminContainer.js
 **/